import * as actionTypes from './action-types-dolphin';

// DOLPHIN
const actionCreatorUpdateDolphinLongSent = (val) => {
  return {
    type: actionTypes.UPDATE_DOLPHIN_LONGSENT,
    data: val
  };
};

const actionCreatorUpdateDolphinSubject = (val) => {
  return {
    type: actionTypes.UPDATE_DOLPHIN_SUBJECT,
    data: val
  };
};

const actionCreatorUpdateDolphinAudioBlobUrl = (val) => {
  return {
    type: actionTypes.UPDATE_DOLPHIN_AUDIOBLOBURL,
    data: val
  };
};

const actionCreatorUpdateDolphin = (val) => {
  return {
    type: actionTypes.UPDATE_DOLPHIN,
    data: val
  };
};

export default {
  actionCreatorUpdateDolphinLongSent,
  actionCreatorUpdateDolphinSubject,
  actionCreatorUpdateDolphinAudioBlobUrl,
  actionCreatorUpdateDolphin
};
